import { NextRouter } from "next/router";

import { BREX_PREFIX, decode } from "./experimentation/urlFormatting";

/**
 * 
The server side router.asPath will be the actual experiment URL rather than rewritten url - this function decodes the url so the path matches the experiment entry rather than the "behind the scenes" url
 */
const swapExperimentLinks = (path: string): string => {
  if (path.includes(BREX_PREFIX)) {
    const decoded = decode(path);
    if (!decoded.isExperiment) return path;
    return decoded.fallBackSlug;
  }
  return path;
};

export const getServerSideCurrentUrl = (
  router: NextRouter,
  basePath: string,
) => {
  const path = swapExperimentLinks(router.asPath);

  const fullUrl = new URL(path, basePath);
  const urlWithNoParams = new URL(fullUrl.pathname, fullUrl.origin);

  return urlWithNoParams.toString();
};

export const getServerSideCurrentSlug = (router: NextRouter) => {
  // This is a hack to get the slug from the router, since the router doesn't have a way to get the slug without the query params
  const url = new URL(
    swapExperimentLinks(router.asPath),
    "http://www.brex.com/",
  );
  return url.pathname;
};
